/**
 * Recursively sort alphabetically the properties of an objects
 * @param obj
 */
export function sortJSON(obj: any): any{
    if (Array.isArray(obj)) {
        // If the value is an array, sort its elements recursively
        return obj.map(sortJSON);
    } else if (obj !== null && typeof obj === "object") {
        // Sort keys of the object
        return Object.keys(obj)
            .sort()
            .reduce((result: any, key) => {
                result[key] = sortJSON(obj[key]); // Recursively sort the value
                return result;
            }, {});
    }
    // Return non-object values as-is
    return obj;
}